import http from '@/plugins/axios';
import store from '@/store';
export default {
  salvar: function salvar(payload) {
    var empresa = store.state.auth.empresa;
    return http.apiEmpresa.post("".concat(empresa.url_instancia, "/v2/push_token"), payload);
  }
};